import { useSelector } from "react-redux";
import { AppAlertContainer } from "./app-alert-container/app-alert-container";
import styles from "./app-alert-list-container.less";
import { getAppAlertsState } from "@redux/selectors/root-selectors";

export const AppAlertsListContainer = () => {
    const { appAlerts } = useSelector(getAppAlertsState);

    if (appAlerts.length === 0) {
        return null;
    }

    return (
        <div className={styles.appAlertListContainer}>
            {appAlerts.map(appAlert => (
                <AppAlertContainer key={`app-alert-${appAlert.id}`} appAlert={appAlert} />
            ))}
        </div>
    );
};